import React, { Component } from 'react';
import config from './config';

class Home extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: true,
            pageNumber: 1,
            apiServiceError: "",
            streamingSubmissionCompleted: false,
            academyID: 1,
            languageID: 1,
            id: "",
            userID: "",
            entryID: "",
            artistName: "",
            title: "",
            categoryName: "",
            categoryNumber: "",
            amazon: "",
            amazonOriginal: "",
            apple: "",
            appleOriginal: "",
            tidal: "",
            tidalOriginal: "",
            spotify: "",
            spotifyOriginal: "",
            other: "",
            otherOriginal: "",
            deezer: "",
            bandcamp: "",
            youTube: "",
            vimeo: "",
            streamingService: "",
            screeningLink: "",
            translations: [],
            resultsArray: [],
            isMultiLink: false,
            classicalLinks: [],
            yangarooBaseId: 0,


            txtWelcome: 1,
            txtUserID: 2,
            txtUserIDRequired: 3,
            txtEntryID: 4,
            txtEntryIDIDRequired: 5,
            txtRetrieveEntry: 6,
            txtEntryNotFound: 7,
            txtNotValidURL: 8,
            txtEntryUpdated: 9,
            txtCompleteSubmission: 10,
            txtReviewAnotherEntry: 11,
            txtEntryIDNotFound: 12,
            txtNoMatchingRecordFound: 13,
            txtErrorOccurred: 14,
            txtSelectEntryToUpdate: 15,
            txtSelect: 16
        }
    }

    componentDidMount() {
        this.loadTranslations();

        this.setState({
            isLoading: false
        })
    }

    handleChange = (event) => {
        this.setState({[event.target.name]: event.target.value});
    }

    async loadTranslations() {
        let url = config.environment.application.baseUrl + '/api/entry/translations/' + this.state.languageID;

        return await fetch (url, {
            method: 'GET',
            headers: new Headers({
                'Content-Type': 'application/json'
            })
        }).then((response) => {
            return response.json();
        }).then((data) => {
            if (config.environment.application.environment !== "prod")
                console.log(data)

            this.setState({translations: data});

            return data;
        }).catch((error) => {
            console.log(error);
        })
    }
    isUserIDValid() {
        return (this.state.userID !== "");
    }

    isEntryIDValid() {
        return (this.state.entryID !== "");
    }

    isVideoCategory() {
        if (this.state.academyID === 2)
            return (this.state.categoryNumber === "52" || this.state.categoryNumber === "53");
        else
            return (this.state.categoryNumber === "73" || this.state.categoryNumber === "74");
    }

    isMusicFilm() {
        return (this.state.academyID === 1 && this.state.categoryNumber === "74");
    }

    isRemixCategory() {
        return (this.state.categoryNumber === "78");
    }

    retrieveEntryForm = (event) => {
        event.preventDefault();
        this.setState({isLoading: true});

        this.retrieveEntry().then((response) => {
            this.setState({isLoading: false});
        

            if (response !== true) {
                this.setState({ apiServiceError: this.getTranslationString(this.state.txtEntryNotFound) });
            }
            else {
                if (this.state.resultsArray.length > 1)
                    this.setState({ pageNumber: 2 });
                else
                    this.setState({ pageNumber: 3 });
            }
        });
    }

    async retrieveEntry() {
        this.setState({
            apiServiceError: ""
        });

        let url = config.environment.application.baseUrl + "/api/entry/retrieveEntry";

        if (config.environment.application.environment !== "prod")
            console.log(url);

        let user_and_entry = {
            userID: this.state.userID,
            entryID: this.state.entryID,
            academyID: this.state.academyID,
            languageID: this.state.languageID
        };

        if (config.environment.application.environment !== "prod")
            console.log(user_and_entry);

        let return_value = await fetch(url, {
            method: 'POST',
            headers: new Headers({
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            }),
            body: JSON.stringify(user_and_entry)
        })
        .then((response) => {
            return response.json();
        })
        .then((data) => {
            if (config.environment.application.environment !== "prod")
                console.log(data);

            if (Array.isArray(data))
            {
                if (data.length === 1) {
                    let current_data = data[0];

                    this.setState({ resultsArray: []});
                    this.setStateForEntry(current_data);
                }
                else {
                    this.setState({
                        resultsArray: data,
                        categoryName: data[0].categoryName,
                        categoryNumber: data[0].categoryNumber,
                        userID: data[0].userID,
                        entryID: data[0].entryID
                    });
                }
    
                return true;
            }
            else
                return false;
        })
        .catch((error) => {
            console.log("In Error : " + error);
            return false;
        });

        return return_value;
    }

    async setStateForEntry(current_data) {
        this.setState({
            apiServiceError: current_data.errorString,
            id: current_data.id,
            categoryName: current_data.categoryName,
            categoryNumber: current_data.categoryNumber,
            artistName: current_data.artistName,
            title: current_data.title,
            amazon: current_data.amazon,
            amazonOriginal: current_data.amazonOriginal,
            apple: current_data.apple,
            appleOriginal: current_data.appleOriginal,
            tidal: current_data.tidal,
            tidalOriginal: current_data.tidalOriginal,
            spotify: current_data.spotify,
            spotifyOriginal: current_data.spotifyOriginal,
            deezer: current_data.deezer,
            bandcamp: current_data.bandcamp,
            youTube: current_data.youTube,
            vimeo: current_data.vimeo,
            other: current_data.other,
            otherOriginal: current_data.otherOriginal,
            isVideo: current_data.isVideo,
            isRemix: current_data.isRemix,
            streamingService: current_data.streamingService,
            screeningLink: current_data.screeningLink,
            isMultiLink: current_data.isMultiLink || false,
            classicalLinks: current_data.multiLinkEntries || [],
            yangarooBaseId: current_data.yangarooBaseId || 0
        });
    }

    selectEntry = async (current_entry) => {
        await this.setStateForEntry(current_entry.current_result).then(this.setState({pageNumber: 3}));
    }

    isValidURLForSource(url_string, source_string)
    {
        if (url_string === undefined || url_string === null || url_string.length === 0)
            return true;

        if (!this.isUrl(url_string))
            return false;

        url_string = url_string.toLowerCase();
        source_string = source_string.toLowerCase();

        if (source_string === "other") {
            //Do the 10 checks here?
            return (
                url_string.indexOf("play.google.com") !== -1 ||
                url_string.indexOf("deezer.com") !== -1 ||
                url_string.indexOf("pandora.com") !== -1 ||
                url_string.indexOf("pandora.app.link") !== -1 ||
                url_string.indexOf("livexlive.com") !== -1 ||
                url_string.indexOf("us.napster.com") !== -1 ||
                url_string.indexOf("iheart.com") !== -1 ||
                url_string.indexOf("qobuz.com") !== -1 ||
                url_string.indexOf("siriusxm.com") !== -1 ||
                url_string.indexOf("soundcloud.com") !== -1 ||
                url_string.indexOf("music.youtube.com") !== -1
            );
        }
        else if (source_string === "youtube")
            return (url_string.indexOf(source_string + ".com") !== -1 || url_string.indexOf("youtu.be") !== -1);
        else
            return (url_string.indexOf(source_string + ".com") !== -1);
    }

    isUrl(url_string)
    {
        let regexp = /^(http|https|ftp):\/\/[^\s/$.?#].[^\s]*$/;
        return regexp.test(url_string);
    }

    restartApplication = (event) => {
        this.setState({
            pageNumber: 1,
            apiServiceError: "",
            streamingSubmissionCompleted: false,
            entryID: "",
            userID: ""
        })
    }

    getTranslation(translation_id, streaming_media_type) {
        for (var x = 0; x < this.state.translations.length; x++) {
            if (this.state.translations[x].translationID === translation_id) {
                if (streaming_media_type === undefined)
                    return {__html: this.state.translations[x].description};
                else
                    return {__html: this.state.translations[x].description.replace("{0}", streaming_media_type)};
            }
                
        }

        return "";
    }

    getTranslationString(translation_id) {
        for (var x = 0; x < this.state.translations.length; x++) {
            if (this.state.translations[x].translationID === translation_id)
                return this.state.translations[x].description;
        }

        return "";
    }

    changeLanguage(new_language) {
        this.setState({languageID: new_language}, () => {
            this.loadTranslations();
        })
    }

    handleClassicalLinkChange = (index, field, value) => {
        const updated = this.state.classicalLinks.map((link, i) =>
            i === index ? { ...link, [field]: value } : link
        );
        this.setState({ classicalLinks: updated });
    }

    addClassicalLink = () => {
        const newLink = {
            id: 0,
            movementName: '',
            amazon: '', apple: '', bandcamp: '', deezer: '',
            spotify: '', tidal: '', vimeo: '', youtubeMusic: '', other: '',
            status: '', hasValue: ''
        };
        this.setState({ classicalLinks: [...this.state.classicalLinks, newLink] });
    }

    saveMultiLinkEntryForm = (event) => {
        event.preventDefault();
        this.saveMultiLinkEntry().then((response) => {
            if (response === true) {
                this.setState({ streamingSubmissionCompleted: true });
            }
        });
    }

    async saveMultiLinkEntry() {
        this.setState({ isLoading: true, apiServiceError: '', streamingSubmissionCompleted: false });

        let url = config.environment.application.baseUrl + '/api/entry/saveMultiLinkEntry';

        let request = {
            academyID: this.state.academyID,
            yangarooBaseId: this.state.yangarooBaseId,
            links: this.state.classicalLinks
        };

        if (config.environment.application.environment !== 'prod')
            console.log(request);

        let return_value = await fetch(url, {
            method: 'POST',
            headers: new Headers({
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }),
            body: JSON.stringify(request)
        })
        .then((response) => response.json())
        .then((data) => {
            if (config.environment.application.environment !== 'prod')
                console.log(data);
            this.setState({ apiServiceError: data.errorString });
            return (data.errorString === '');
        })
        .catch((error) => {
            console.log('In Error : ' + error);
            return false;
        });

        this.setState({ isLoading: false });
        return return_value;
    }

    multiLinkStreamingLinkView() {
        const providers = [
            { key: 'amazon',       label: 'Amazon',        source: 'amazon'   },
            { key: 'apple',        label: 'Apple',         source: 'apple'    },
            { key: 'bandcamp',     label: 'Bandcamp',      source: 'bandcamp' },
            { key: 'deezer',       label: 'Deezer',        source: 'deezer'   },
            { key: 'spotify',      label: 'Spotify',       source: 'spotify'  },
            { key: 'tidal',        label: 'Tidal',         source: 'tidal'    },
            { key: 'vimeo',        label: 'Vimeo',         source: 'vimeo'    },
            { key: 'youtubeMusic', label: 'YouTube Music', source: 'youtube'  },
            { key: 'other',        label: 'Other',         source: 'other'    },
        ];

        return (
            <div className="row">
                <br />
                <div className="col-12 col-sm-10 offset-sm-1">
                    <h5 className="text-center">{this.state.categoryNumber}. {this.state.categoryName}</h5>
                    <div className="text-center">
                        <b><span dangerouslySetInnerHTML={this.getTranslation(this.state.txtUserID)} />:</b> {this.state.userID}<br />
                        <b><span dangerouslySetInnerHTML={this.getTranslation(this.state.txtEntryID)} />:</b> {this.state.entryID}<br />
                        <br />
                        {this.state.title} ({this.state.artistName})<br />
                    </div>
                    <br />
                    {this.state.classicalLinks.map((link, index) => (
                        <div key={index}>
                            <div className="entry-form">
                                <div className="mb-2">
                                    <label><b>Movement Name</b></label>
                                    <input
                                        type="text"
                                        placeholder="Movement Name"
                                        value={link.movementName}
                                        onChange={(e) => this.handleClassicalLinkChange(index, 'movementName', e.target.value)}
                                        className="form-control"
                                    />
                                </div>
                                {providers.map(provider => (
                                    <div key={provider.key} className="row mb-2 align-items-start">
                                        <div className="col-3">
                                            <label><b>{provider.label}</b></label>
                                        </div>
                                        <div className="col-9">
                                            <input
                                                type="text"
                                                value={link[provider.key]}
                                                onChange={(e) => this.handleClassicalLinkChange(index, provider.key, e.target.value)}
                                                className="form-control"
                                            />
                                            {!this.isValidURLForSource(link[provider.key], provider.source) &&
                                                <div className="red-text"><span dangerouslySetInnerHTML={this.getTranslation(this.state.txtNotValidURL, provider.label)} /></div>
                                            }
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <hr />
                        </div>
                    ))}
                    <button type="button" className="btn btn-secondary mb-3" onClick={this.addClassicalLink}>
                        + Add Movement
                    </button>
                    <br />
                    {this.state.apiServiceError !== "" &&
                        <div className="alert alert-danger">{this.state.apiServiceError}</div>
                    }
                    {this.state.streamingSubmissionCompleted &&
                        <div className="alert alert-success"><span dangerouslySetInnerHTML={this.getTranslation(this.state.txtEntryUpdated)} /></div>
                    }
                    <button onClick={this.saveMultiLinkEntryForm} className="btn btn-primary" style={{width: "45%"}}>{this.getTranslationString(this.state.txtCompleteSubmission)}</button>
                    <button onClick={this.restartApplication} className="btn btn-secondary" style={{width: "45%", float: "right"}}>{this.getTranslationString(this.state.txtReviewAnotherEntry)}</button>
                    <br /><br /><br />
                </div>
            </div>
        );
    }

    saveEntryForm = (event) => {
        event.preventDefault();

        this.saveEntry().then((response) => {
            if (response === true) {
                this.setState({ streamingSubmissionCompleted: true });
            }
        });
    }

    async saveEntry() {
        this.setState({
            isLoading: true,
            apiServiceError: "",
            streamingSubmissionCompleted: false
        });

        let url = config.environment.application.baseUrl + "/api/entry/saveEntry";

        if (config.environment.application.environment !== "prod")
            console.log(url);

        let user_and_entry = {
            id: this.state.id,
            academyID: this.state.academyID,
            userID: this.state.userID,
            entryID: this.state.entryID,
            artistName: this.state.artistName,
            title: this.state.title,
            categoryName: this.state.categoryName,
            categoryNumber: this.state.categoryNumber,
            amazon: this.state.amazon,
            amazonOriginal: this.state.amazonOriginal,
            apple: this.state.apple,
            appleOriginal: this.state.appleOriginal,
            tidal: this.state.tidal,
            tidalOriginal: this.state.tidalOriginal,
            spotify: this.state.spotify,
            spotifyOriginal: this.state.spotifyOriginal,
            deezer: this.state.deezer,
            bandcamp: this.state.bandcamp,
            youTube: this.state.youTube,
            vimeo: this.state.vimeo,
            other: this.state.other,
            otherOriginal: this.state.otherOriginal,
            streamingService: this.state.streamingService,
            screeningLink: this.state.screeningLink
        };

        if (config.environment.application.environment !== "prod")
            console.log(user_and_entry);

        let return_value = await fetch(url, {
            method: 'POST',
            headers: new Headers({
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            }),
            body: JSON.stringify(user_and_entry)
        })
        .then((response) => {
            return response.json();
        })
        .then((data) => {
            if (config.environment.application.environment !== "prod")
                console.log(data);

            this.setState({
                id: data.id,
                apiServiceError: data.errorString,
                categoryName: data.categoryName,
                categoryNumber: data.categoryNumber,
                artistName: data.artistName,
                title: data.title,
                amazon: data.amazon,
                amazonOriginal: data.amazonOriginal,
                apple: data.apple,
                appleOriginal: data.appleOriginal,
                tidal: data.tidal,
                tidalOriginal: data.tidalOriginal,
                spotify: data.spotify,
                spotifyOriginal: data.spotifyOriginal,
                deezer: data.deezer,
                bandcamp: data.bandcamp,
                youTube: data.youTube,
                vimeo: data.vimeo,
                other: data.other,
                otherOriginal: data.otherOriginal,
                streamingService: data.streamingService,
                screeningLink: data.screeningLink
            });

            return (data.errorString === "");
        })
        .catch((error) => {
            console.log("In Error : " + error);
            return false;
        });

        this.setState({isLoading: false});

        return return_value;
    }

    userAndEntryView() {
        return (
            <div>
                <div className="row">
                    <div className="col-12 col-sm-10 offset-sm-1 col-md-6 offset-md-3">
                        <span dangerouslySetInnerHTML={this.getTranslation(this.state.txtWelcome)} /><br />
                        <br />
                    </div>
                </div>
                <div className="row">
                    <div className="col-12 col-sm-8 offset-sm-2 col-md-6 offset-md-3">
                        {
                            (this.state.academyID !== 1 &&
                                <div className="text-center">
                                    <button className="btn btn-link" onClick={() => {this.changeLanguage(1)}}>English</button>
                                    <button className="btn btn-link" onClick={() => {this.changeLanguage(2)}}>Español</button>
                                    <button className="btn btn-link" onClick={() => {this.changeLanguage(3)}}>Portugués</button>
                                </div>
                            )
                        }
                        {
                            (this.state.apiServiceError !== "" &&
                                <div className="alert alert-danger">{this.state.apiServiceError}</div>
                            )
                        }
                        <div className="entry-form">
                            <label htmlFor="userID"><b><span dangerouslySetInnerHTML={this.getTranslation(this.state.txtUserID)} /></b></label>
                            <input type="text" name="userID" value={this.state.userID} className="form-control" required onChange={this.handleChange} />
                            {
                                (!this.isUserIDValid() && 
                                    <div className="red-text"><span dangerouslySetInnerHTML={this.getTranslation(this.state.txtUserIDRequired)} /></div>
                                )
                            }
                            <br />
                            <label htmlFor="entryID"><b><span dangerouslySetInnerHTML={this.getTranslation(this.state.txtEntryID)} /></b></label>
                            <input type="text" name="entryID" value={this.state.entryID} className="form-control" required onChange={this.handleChange} />
                            {
                                (!this.isEntryIDValid() && 
                                    <div className="red-text"><span dangerouslySetInnerHTML={this.getTranslation(this.state.txtEntryIDIDRequired)} /></div>
                                )
                            }
                            <br />
                            <button onClick={this.retrieveEntryForm} disabled={!this.isUserIDValid() && !this.isEntryIDValid()} className="btn btn-primary w-100">{this.getTranslationString(this.state.txtRetrieveEntry)}</button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    streamingLinkView() {
        if (this.state.isMultiLink) return this.multiLinkStreamingLinkView();

        return (
            <div className="row">
                <br />
                <div className="col-12 col-sm-8 offset-sm-2 col-md-6 offset-md-3">
                    <h5 className="text-center">{this.state.categoryNumber}. {this.state.categoryName}</h5>
                    <div className="text-center">
                        <b><span dangerouslySetInnerHTML={this.getTranslation(this.state.txtUserID)} />:</b> { this.state.userID }<br />
                        <b><span dangerouslySetInnerHTML={this.getTranslation(this.state.txtEntryID)} />:</b> { this.state.entryID }<br />
                        <br />
                        {this.state.title} ({this.state.artistName})<br />
                    </div>
                    <br />
                    {
                        (!this.isVideoCategory() &&
                            <div>
                                <div>
                                    <label htmlFor="amazon"><b>Amazon</b></label>
                                    <input type="text" name="amazon" value={this.state.amazon} onChange={this.handleChange} className="form-control" />
                                    {
                                        (!this.isValidURLForSource(this.state.amazon, 'amazon') &&
                                            <div className="red-text"><span dangerouslySetInnerHTML={this.getTranslation(this.state.txtNotValidURL, "Amazon")} /></div>
                                        )
                                    }
                                </div>
                                <div>
                                    <label htmlFor="apple"><b>Apple</b></label>
                                    <input type="text" name="apple" value={this.state.apple} onChange={this.handleChange} className="form-control" />
                                    {
                                        (!this.isValidURLForSource(this.state.apple, 'apple') &&
                                            <div className="red-text"><span dangerouslySetInnerHTML={this.getTranslation(this.state.txtNotValidURL, "Apple")} /></div>
                                        )
                                    }
                                </div>
                                {
                                    (this.state.academyID === 2 &&
                                        <div>
                                            <label htmlFor="bandcamp"><b>Bandcamp</b></label>
                                            <input type="text" name="bandcamp" value={this.state.bandcamp} onChange={this.handleChange} className="form-control" />
                                            {
                                                (!this.isValidURLForSource(this.state.bandcamp, 'bandcamp') &&
                                                    <div className="red-text"><span dangerouslySetInnerHTML={this.getTranslation(this.state.txtNotValidURL, "Bandcamp")} /></div>
                                                )
                                            }
                                        </div>
                                    )
                                }
                                {
                                    (this.state.academyID === 2 &&
                                        <div>
                                            <label htmlFor="deezer"><b>Deezer</b></label>
                                            <input type="text" name="deezer" value={this.state.deezer} onChange={this.handleChange} className="form-control" />
                                            {
                                                (!this.isValidURLForSource(this.state.deezer, 'deezer') &&
                                                    <div className="red-text"><span dangerouslySetInnerHTML={this.getTranslation(this.state.txtNotValidURL, "Deezer")} /></div>
                                                )
                                            }
                                        </div>
                                    )
                                }
                                <div>
                                    <label htmlFor="spotify"><b>Spotify</b></label>
                                    <input type="text" name="spotify" value={this.state.spotify} onChange={this.handleChange} className="form-control" />
                                    {
                                        (!this.isValidURLForSource(this.state.spotify, 'spotify') &&
                                            <div className="red-text"><span dangerouslySetInnerHTML={this.getTranslation(this.state.txtNotValidURL, "Spotify")} /></div>
                                        )
                                    }
                                </div>
                                <div>
                                    <label htmlFor="tidal"><b>Tidal</b></label>
                                    <input type="text" name="tidal" value={this.state.tidal} onChange={this.handleChange} className="form-control" />
                                    {
                                        (!this.isValidURLForSource(this.state.tidal, 'tidal') &&
                                            <div className="red-text"><span dangerouslySetInnerHTML={this.getTranslation(this.state.txtNotValidURL, "Tidal")} /></div>
                                        )
                                    }
                                </div>
                                {
                                    (this.state.academyID === 2 &&
                                        <div>
                                            <label htmlFor="youTube"><b>YouTube</b></label>
                                            <input type="text" name="youTube" value={this.state.youTube} onChange={this.handleChange} className="form-control" />
                                            {
                                                (!this.isValidURLForSource(this.state.youTube, 'youtube') &&
                                                    <div className="red-text"><span dangerouslySetInnerHTML={this.getTranslation(this.state.txtNotValidURL, "YouTube")} /></div>
                                                )
                                            }
                                        </div>
                                    )
                                }
                                {
                                    (this.state.academyID === 1 &&
                                        <div>
                                            <label htmlFor="other"><b>Other</b> <span className="small">Google Play Music, Deezer, Pandora Premium, Slacker Plus, Napster (Merged with Rhapsody), iHeart Radio All Access, Qobuz, Sirius XM All Access, Soundcloud Premium, YouTube Music Premium</span></label>
                                            <input type="text" name="other" value={this.state.other} onChange={this.handleChange} className="form-control" />
                                            {
                                                (!this.isValidURLForSource(this.state.other, 'other') &&
                                                    <div className="red-text"><span dangerouslySetInnerHTML={this.getTranslation(this.state.txtNotValidURL, "Other")} /></div>
                                                )
                                            }
                                        </div>
                                    )
                                }

                                {
                                    (this.isRemixCategory() && 
                                        <div>
                                            <div>
                                                <hr />
                                            </div>
                                            <div>
                                                <label htmlFor="amazonOriginal"><b>Amazon (Original Recording)</b></label>
                                                <input type="text" name="amazonOriginal" value={this.state.amazonOriginal} onChange={this.handleChange} className="form-control" />
                                                {
                                                    (!this.isValidURLForSource(this.state.amazonOriginal, 'amazon') &&
                                                        <div className="red-text"><span dangerouslySetInnerHTML={this.getTranslation(this.state.txtNotValidURL, "Amazon")} /></div>
                                                    )
                                                }
                                            </div>
                                            <div>
                                                <label htmlFor="appleOriginal"><b>Apple (Original Recording)</b></label>
                                                <input type="text" name="appleOriginal" value={this.state.appleOriginal} onChange={this.handleChange} className="form-control" />
                                                {
                                                    (!this.isValidURLForSource(this.state.appleOriginal, 'apple') &&
                                                        <div className="red-text"><span dangerouslySetInnerHTML={this.getTranslation(this.state.txtNotValidURL, "Apple")} /></div>
                                                    )
                                                }
                                            </div>
                                            <div>
                                                <label htmlFor="spotifyOriginal"><b>Spotify (Original Recording)</b></label>
                                                <input type="text" name="spotifyOriginal" value={this.state.spotifyOriginal} onChange={this.handleChange} className="form-control" />
                                                {
                                                    (!this.isValidURLForSource(this.state.spotifyOriginal, 'spotify') &&
                                                        <div className="red-text"><span dangerouslySetInnerHTML={this.getTranslation(this.state.txtNotValidURL, "Spotify")} /></div>
                                                    )
                                                }
                                            </div>
                                            <div>
                                                <label htmlFor="tidalOriginal"><b>Tidal (Original Recording)</b></label>
                                                <input type="text" name="tidalOriginal" value={this.state.tidalOriginal} onChange={this.handleChange} className="form-control" />
                                                {
                                                    (!this.isValidURLForSource(this.state.tidalOriginal, 'tidal') &&
                                                        <div className="red-text"><span dangerouslySetInnerHTML={this.getTranslation(this.state.txtNotValidURL, "Tidal")} /></div>
                                                    )
                                                }
                                            </div>
                                            <div>
                                                <label htmlFor="otherOriginal"><b>Other (Original Recording)</b> <b>Other</b> <span className="small">Google Play Music, Deezer, Pandora Premium, Slacker Plus, Napster (Merged with Rhapsody), iHeart Radio All Access, Qobuz, Sirius XM All Access, Soundcloud Premium, YouTube Music Premium</span></label>
                                                <input type="text" name="otherOriginal" value={this.state.otherOriginal} onChange={this.handleChange} className="form-control" />
                                                {
                                                    (!this.isValidURLForSource(this.state.otherOriginal, 'other') &&
                                                        <div className="red-text"><span dangerouslySetInnerHTML={this.getTranslation(this.state.txtNotValidURL, "Other")} /></div>
                                                    )
                                                }
                                            </div>
                                        </div>
                                    )
                                }
                            </div>
                        )
                    }
                    {
                        (this.isVideoCategory() && !this.isMusicFilm() && 
                            <div>
                                <div>
                                    <label htmlFor="vimeo"><b>Vimeo</b></label>
                                    <input type="text" name="vimeo" value={this.state.vimeo} onChange={this.handleChange} className="form-control" />
                                    {
                                        (!this.isValidURLForSource(this.state.vimeo, 'vimeo') &&
                                            <div className="red-text"><span dangerouslySetInnerHTML={this.getTranslation(this.state.txtNotValidURL, "Vimeo")} /></div>
                                        )
                                    }
                                </div>
                                <div>
                                    <label htmlFor="youTube"><b>YouTube</b></label>
                                    <input type="text" name="youTube" value={this.state.youTube} onChange={this.handleChange} className="form-control" />
                                    {
                                        (!this.isValidURLForSource(this.state.youTube, 'youtube') &&
                                            <div className="red-text"><span dangerouslySetInnerHTML={this.getTranslation(this.state.txtNotValidURL, "YouTube")} /></div>
                                        )
                                    }
                                </div>
                            </div>
                        )
                    }
                    {
                        (this.isVideoCategory() && this.isMusicFilm() && 
                            <div>
                                <div>
                                    <label htmlFor="streamingService"><b>Streaming Service</b></label>
                                    <input type="text" name="streamingService" value={this.state.streamingService} onChange={this.handleChange} className="form-control" />
                                </div>
                                <div>
                                    <label htmlFor="screeningLink"><b>Screening Link</b></label>
                                    <input type="text" name="screeningLink" value={this.state.screeningLink} onChange={this.handleChange} className="form-control" />
                                </div>
                            </div>
                        )
                    }

                    <br />
                    {
                        (this.state.apiServiceError !== "" &&
                            <div className="alert alert-danger">{this.state.apiServiceError}</div>
                        )
                    }
                    {
                        (this.state.streamingSubmissionCompleted &&
                            <div className="alert alert-success"><span dangerouslySetInnerHTML={this.getTranslation(this.state.txtEntryUpdated)} /></div>
                        )
                    }
                    <button onClick={this.saveEntryForm} className="btn btn-primary" style={{width: "45%"}}>{this.getTranslationString(this.state.txtCompleteSubmission)}</button>
                    <button onClick={this.restartApplication} className="btn btn-secondary" style={{width: "45%", float: "right"}}>{this.getTranslationString(this.state.txtReviewAnotherEntry)}</button>
                    <br />
                    <br />
                    <br />
                </div>
            </div>
        )
    }

    chooseEntry() {
        return (
            <div>
                <div className="row">
                    <div className="col-12 col-sm-8 offset-sm-2 col-md-6 offset-md-3">
                        <h5 className="text-center">{this.state.categoryNumber}. {this.state.categoryName}</h5>
                        <div className="text-center">
                            <b><span dangerouslySetInnerHTML={this.getTranslation(this.state.txtUserID)} />:</b> { this.state.userID }<br />
                            <b><span dangerouslySetInnerHTML={this.getTranslation(this.state.txtEntryID)} />:</b> { this.state.entryID }<br />
                            <br />
                            <b><span dangerouslySetInnerHTML={this.getTranslation(this.state.txtSelectEntryToUpdate)} /></b><br />
                        </div>
                    </div>
                </div>
                {this.state.resultsArray.map((current_result) => {
                    return (
                        <div className="row m-2" key={`current_result_${current_result.id}`}>
                            <div className="col-12 col-sm-8 offset-sm-2 col-md-6 offset-md-3">
                                <button className="btn btn-primary" onClick={() => this.selectEntry({current_result})}><span dangerouslySetInnerHTML={this.getTranslation(this.state.txtSelect)} /></button> {current_result.title} ({current_result.artistName})
                            </div>
                        </div>
                    )
                })}
            </div>
        )
    }

    //<img src="/Images/LatinRecordingAcademy.png" className="img-fluid" alt="Latin Recording Academy" /><br />
    render() {
        if (this.state.translations.length === 0)
            return null;

        return (
            <div>
                <div className="row">
                    <div className="col-12 mx-auto text-center">
                        <br />
                        <img src="/Images/logo.png" className="img-fluid" alt="Recording Academy" /><br />
                        <br />
                        <br />
                    </div>
                </div>
                {
                    (this.state.pageNumber === 1 &&
                        this.userAndEntryView()
                    )
                }
                {
                    (this.state.pageNumber === 2 && 
                        this.chooseEntry()
                    )
                }
                {
                    (this.state.pageNumber === 3 &&
                        this.streamingLinkView()
                    )
                }
                <br />
                <br />
                <br />
            </div>
        )
    }
}

export default Home;
